import React from 'react';

export const PieChartIcon = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 18 18'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill='currentColor'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 9V1C3.58164 1.00046 0 4.58239 0 9.00085C0 13.4196 3.5821 17.0017 8.00085 17.0017C12.4196 17.0017 16.0017 13.4196 16.0017 9.00085C16.0017 9.00057 16.0017 9.00028 16.0017 9H8Z'
    />
    <path
      fill='currentColor'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9 7.995V0C13.4166 0 16.9973 3.57902 17 7.995H9ZM9 8H17H17.0017V8.00085C17.0017 12.4196 13.4196 16.0017 9.00085 16.0017C4.5821 16.0017 1 12.4196 1 8.00085C1 3.58239 4.58164 0.000459705 9 0C4.58172 0 1 3.58172 1 8C1 12.4183 4.58172 16 9 16C13.4166 16 16.9973 12.421 17 8.005H9V8Z'
    />
  </svg>
);
